import { useEffect } from "react";
import { ProfileCardItem } from "@/components/atoms/Items/ProfileCardItem";
import * as S from "./ProfileList.style";
import { MyProfileSelectProps } from "@/pages/mypage/MyProfileSelectPage";

interface ProfileListProps {
  data?: MyProfileSelectProps[];
  onClick?: any;
  selectedProfile?: MyProfileSelectProps;
}

export const ProfileList = ({
  data,
  onClick,
  selectedProfile,
}: ProfileListProps) => {
  console.log("data", data);

  useEffect(() => {
    const el = document.getElementById("profile-list");
    if (el) el.scrollTop = 0;
  }, []);

  return (
    <S.ProfileListWrapper>
      <S.ProfileList id="profile-list">
        {data?.map((item: MyProfileSelectProps, idx: number) => {
          return (
            <ProfileCardItem
              data={item}
              key={idx}
              onClick={onClick}
              selectedProfile={selectedProfile}
            />
          );
        })}
        <ProfileCardItem />
      </S.ProfileList>
    </S.ProfileListWrapper>
  );
};
